import { render, staticRenderFns } from "./PaymentManagement.vue?vue&type=template&id=12a3eb3d&scoped=true&"
import script from "./PaymentManagement.vue?vue&type=script&lang=js&"
export * from "./PaymentManagement.vue?vue&type=script&lang=js&"
import style0 from "./PaymentManagement.vue?vue&type=style&index=0&id=12a3eb3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3eb3d",
  null
  
)

export default component.exports